import { fromEvent } from 'rxjs';
import { map, filter, take } from 'rxjs/operators';
import { Maybe } from 'maybe-not';
export function _sendMessage(recipient, type, protocol, message, guid = null, status = 'success') {
    const recipientWindow = window.isTesting ? window : recipient;
    recipientWindow.postMessage({
        tectonic: true,
        value: message.withDefault(''),
        status,
        type,
        protocol,
        guid
    }, '*');
}
export function sendMessage(method, message) {
    _sendMessage(window.parent, method, 'MESSAGE', message);
}
export function sendBroadcast(method, message) {
    _sendMessage(window, method, 'BROADCAST', message);
    if (window.isTesting) {
        return;
    }
    Array.prototype.slice
        .call(document.querySelectorAll('tecton-platform-outlet, tecton-outlet, tecton-tab-pane'))
        .forEach((outletNode) => {
        const iframe = outletNode.shadowRoot && outletNode.shadowRoot.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
            _sendMessage(iframe.contentWindow, method, 'BROADCAST', message);
        }
    });
}
function checkTypeAndFormat(type, obs, protocol, guid = null) {
    return obs.pipe(filter((e) => {
        return (e.data.type === type &&
            (!guid || e.data.guid === guid) &&
            e.data.protocol === protocol);
    }), map(e => {
        if (e.data.status === 'success') {
            // tslint:disable-next-line:no-object-literal-type-assertion
            return {
                status: 'success',
                value: e.data.value && JSON.parse(e.data.value),
                sender: e.source,
                type,
                guid: e.data.guid
            };
        }
        else {
            // tslint:disable-next-line:no-object-literal-type-assertion
            return {
                status: 'error',
                message: e.data.value && JSON.parse(e.data.value).message,
                sender: e.source,
                type,
                guid: e.data.guid
            };
        }
    }));
}
export default class MessageBus {
    constructor() {
        this.messageNum = 0;
        this.firehose$ = fromEvent(window, 'message').pipe(filter((e) => e.data.tectonic));
    }
    onMessage(type, protocol = 'MESSAGE', guid = null) {
        return checkTypeAndFormat(type, this.firehose$, protocol, guid).pipe(map(_handleMessage));
    }
    sendRequest(type, message) {
        const guid = this.getNextMessageNumber();
        _sendMessage(window.parent, type, 'REQUEST', message, guid, 'success');
        return this.onMessage(type, 'RESPONSE', guid)
            .pipe(take(1))
            .toPromise();
    }
    sendResponse(type, generateResponse) {
        return this.onMessage(type, 'REQUEST').subscribe(response => {
            return Promise.resolve()
                .then(() => {
                if (response.status === 'success') {
                    return generateResponse(response.value, response.sender);
                }
                else {
                    throw Error("Don't send Error Message as Request!");
                }
            })
                .then(body => _responseCallback(response.sender, response.type, body, response.guid, 'success'))
                .catch(err => _responseCallback(response.sender, response.type, { message: err.message }, response.guid, 'error'));
        });
    }
    getNextMessageNumber() {
        const nextNum = this.messageNum + 1;
        this.messageNum = nextNum;
        return nextNum;
    }
}
function _handleMessage(response) {
    if (response.status === 'success') {
        return response;
    }
    throw response;
}
function _responseCallback(sender, type, data, guid = null, status) {
    _sendMessage(sender, type, 'RESPONSE', Maybe.maybe(data).map(JSON.stringify), guid, status);
}
//# sourceMappingURL=message-bus.js.map